/**
 * Rialto Film Guide - Main App Component
 */

import { useState, useEffect } from '@wordpress/element';
import { AuthProvider } from './context/AuthContext';
import { FilmProvider } from './context/FilmContext';
import { ReminderProvider } from './context/ReminderContext';

// Components
import FilmSchedule from './components/FilmSchedule';
import FilmGrid from './components/FilmGrid';
import FilmSearch from './components/FilmSearch';
import WhatsPlayingNow from './components/WhatsPlayingNow';
import PickOfDay from './components/PickOfDay';
import PickOfWeek from './components/PickOfWeek';
import FilmSlider from './components/FilmSlider';
import NetflixHome from './components/NetflixHome';
import HeroSection from './components/HeroSection';
import FilmRow from './components/FilmRow';
import TrailerModal from './components/TrailerModal';
import FilmCard from './components/FilmCard';
import YouTubeGallery from './components/YouTubeGallery';
import ReminderModal from './components/ReminderModal';
import MyReminders from './components/MyReminders';
import StandaloneHero from './components/StandaloneHero';

const componentMap = {
    'schedule': FilmSchedule,
    'films': FilmGrid,
    'search': FilmSearch,
    'whats-playing': WhatsPlayingNow,
    'pick-of-day': PickOfDay,
    'pick-of-week': PickOfWeek,
    'slider': FilmSlider,
    'netflix-home': NetflixHome,
    'hero': HeroSection,
    'film-row': FilmRow,
    'film-card': FilmCard,
    'youtube-gallery': YouTubeGallery,
    'my-reminders': MyReminders,
    'standalone-hero': StandaloneHero,
};

export default function App({ component, ...props }) {
    const Component = componentMap[component];

    return (
        <AuthProvider>
            <FilmProvider>
                <ReminderProvider>
                    {Component ? <Component {...props} /> : null}
                    <ReminderModal />
                </ReminderProvider>
            </FilmProvider>
        </AuthProvider>
    );
}
